import { Tag } from "antd";
import trans, { formatDateTime } from "../../../../utils";

function HistoryEventItem({ event }) {
  const statusColors = {
    todo: `blue`,
    inProgress: `orange`,
    done: `green`,
    // delayed: `red`,
    unassigned: `default`,
  };

  return (
    <div className="d-flex flex-column gap-1 w-100">
      <div className={`fs-6`}>
        <p className="mb-0">
          {trans("Task transfered from")}{" "}
          <Tag
            color={statusColors[event.from] || statusColors.unassigned}
            className="text-capitalize"
          >
            {trans(event.from)}
          </Tag>{" "}
          {trans("to")}{" "}
          <Tag
            color={statusColors[event.to] || statusColors.unassigned}
            className="text-capitalize"
          >
            {trans(event.to)}
          </Tag>
        </p>
      </div>

      <div className="text-secondary fs-6">
        <p className="mb-0">{formatDateTime(event?.changedAt)}</p>
      </div>

      {event.changedBy ? (
        <div className={`personColor`}>
          <p className="mb-0">{event.changedByUser.name}</p>
        </div>
      ) : (
        <div className={`personColor`}>
          <p className="mb-0">{trans("System")}</p>
        </div>
      )}
    </div>
  );
}

export function TaskHistory({ data }) {
  const events = data?.statusHistory;
  console.log(data);
  return (
    <div className="w-100 h-100 overflow-auto">
      <div className="p-3">
        {/* Header */}
        <div className="mb-4">
          <h6 className="fs-16 fw-700 brand-700">
            {trans("Task History Details")}
          </h6>
        </div>

        {/* Events */}
        <div className="d-flex flex-column gap-4">
          {events.map((event) => (
            <div key={event.id}>
              <HistoryEventItem event={event} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
